import React from 'react';
import useModalEscape from './useModalEscape';

function productImageUrl(url) {
  if (!url) return '';
  const value = String(url);
  if (value.startsWith('/')) return value;
  return `/api/media/product-image?url=${encodeURIComponent(value)}`;
}

export default function ProductInfoDialog({ product, formatPrice, onClose, onTryOn, t }) {
  useModalEscape(Boolean(product), onClose);

  if (!product) return null;
  const href = product.affiliate_url || product.product_url;

  return (
    <div className="ct-product-info-overlay" role="presentation" onMouseDown={onClose}>
      <section
        className="ct-product-info-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ct-product-info-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button type="button" className="ct-product-info-close" onClick={onClose} aria-label={t('tryon.hide')}>
          <i className="ph ph-x"></i>
        </button>
        <div className="ct-product-info-image">
          {product.image_url ? <img src={productImageUrl(product.image_url)} alt={product.name} /> : <i className="ph ph-shopping-bag"></i>}
          {product.lane ? <em>{t(`similarRail.lane.${product.lane}`)}</em> : null}
        </div>
        <div className="ct-product-info-copy">
          <p className="ct-kicker">{product.store || product.brand || t('productInfo.kicker')}</p>
          <h3 id="ct-product-info-title">{product.name}</h3>
          <dl>
            <div>
              <dt>{t('productInfo.price')}</dt>
              <dd>{formatPrice(product)}</dd>
            </div>
            <div>
              <dt>{t('productInfo.match')}</dt>
              <dd>{product.itemCategory || t('productInfo.matchFallback')}</dd>
            </div>
          </dl>
          <p>{t('productInfo.copy')}</p>
          <div className="ct-product-info-actions">
            {onTryOn ? (
              <button
                type="button"
                onClick={() => {
                  onClose();
                  onTryOn();
                }}
              >
                <i className="ph ph-magic-wand"></i>
                {t('productInfo.tryOn')}
              </button>
            ) : null}
            {href ? (
              <a href={href} target="_blank" rel="noreferrer">
                {t('productInfo.openShop')}
              </a>
            ) : null}
          </div>
        </div>
      </section>
    </div>
  );
}
